import { inject } from "@angular/core";
import { Router } from "@angular/router";

export function handleNavigationError(): Promise<boolean> {
  // TODO: if error occurs in a root route already, app stucks in an infinite loop
  const router = inject(Router);
  return router.navigate(["/"]);
}
